import styled from 'styled-components';

export const UiTagListPage = styled.div`
`;